import { createAction } from 'redux-act';

import { ISetError, types } from './types';

export const setError = createAction<ISetError>(types.SET_ERROR);
export const clearError = createAction(types.CLEAR_ERROR);
